import styled from "styled-components";

export const Container = styled.div`
  padding: 0 30px 30px 30px;

  & .rate-wrapper {
    display: flex;
    justify-content: center;
  }

  & .upload-wrapper {
    margin-top: 20px;
  }
`;
